module.exports = __webpack_public_path__ + "img/docker-on-aws.e7b004bf.png";